import { t } from '@/i18n';
import { BreadcrumbInfoItems } from 'src/components/SimpleBreadcrumb';

export const breadcrumb: BreadcrumbInfoItems = [
  {
    label: t('pages.application_store.breadcrumb.store_label1'),
    link: '/application',
  },
  {
    label: t('pages.application_store.breadcrumb.store_label2'),
    link: '/application/store',
  },
  {
    label: t('pages.application_store.breadcrumb.store_label3'),
  },
];
